export default class LocalStorageKeys {
    static userList = "users-list";
    static firstTime = "is-first-time";
    static loggedUser = "logged-user";
    static globalHistory = "global-history";
    static books = "books"
}